import React from 'react';
import { Link } from 'react-router-dom';
import { DestinationCard } from '../components/ui/Cards';
import { destinations } from '../data';
import './ListPage.css';

export default function Destinations() {
  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">Where to Go</div>
          <h1>Destinations</h1>
          <p>8 incredible destinations reachable from Marrakech</p>
        </div>
      </div>

      <section className="section section-white">
        <div className="container">
          <div className="grid-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>
            {destinations.map(d => (
              <DestinationCard key={d.id} destination={d} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
